import lodash from 'lodash';
import React from 'react';
import MomentUtils from '@date-io/moment';
import {
    withStyles,
    TextField,
    Typography,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Row, Col } from 'antd';
import { SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, GET_LEAD_PAYMENT_APPROVAL_DRIVERS_CATALOG } from '../../constants';
import styles from './styles';


class PostTransactionDetails extends React.Component {
    handleChangeField = (key, value) => {
        const { dispatch, dataModel } = this.props;

        dataModel.set(key, value);

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            payload: {
                dataModel,
                $lastUpdateTime: Date.now(),
            },
        });
    }

    handleSearchDriver = (event, value, reason) => {
        const { dispatch } = this.props;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            payload: {
                $lastUpdateTime: Date.now(),
                'catalogs.drivers.filters.searchByName': value,
            },
        });

        if (reason === 'input' && (value.length >= 3 || value.length === 0)) {
            this.fetchDrivers();
        }
    }

    fetchDrivers = lodash.debounce(() => {
        const { dispatch } = this.props;

        dispatch({ type: GET_LEAD_PAYMENT_APPROVAL_DRIVERS_CATALOG });
    }, 300);

    getValue(path, canBeZero) {
        const { dataModel } = this.props;

        const value = dataModel.get(path);

        if (value === 0 && canBeZero) {
            return 0;
        }

        return value || '';
    }

    render() {
        const {
            isLoading,
            dataModel,
            catalogs,
            formIsLocked,
        } = this.props;
        const finTree = dataModel.schema.tree;
        const boughtTree = finTree.bought_info.type.tree;

        return (
            <Row>
                <Col span={24}>
                    <Typography variant="h5" color="primary" gutterBottom>Post Transaction Details</Typography>
                </Col>
                <Col span={11}>
                    <div>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                // disableToolbar
                                variant="inline"
                                inputVariant="outlined"
                                label={boughtTree.bought_date.displayName}
                                disabled={formIsLocked || isLoading}
                                value={dataModel.bought_info.bought_date || null}
                                onChange={(value) => this.handleChangeField('bought_info.bought_date', value.toISOString())}
                                // InputAdornment={{ position: 'end' }}
                                autoOk
                                format="D MMM YYYY"
                                margin="dense"
                                fullWidth
                                orientation="landscape"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <Autocomplete
                            options={boughtTree.bought_by_driver.externalData}
                            getOptionLabel={(option) => {
                                if (lodash.isPlainObject(option)) {
                                    return `${option.person.first_name} ${option.person.last_name}`;
                                }

                                return option;
                            }}
                            value={dataModel.bought_info.bought_by_driver || ''}
                            disabled={formIsLocked || isLoading}
                            onChange={(event, value) => this.handleChangeField('bought_info.bought_by_driver', value)}
                            inputValue={catalogs.drivers.filters.searchByName || ''}
                            loading={boughtTree.bought_by_driver.isLoading}
                            onInputChange={this.handleSearchDriver}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={false}
                                    label={boughtTree.bought_by_driver.displayName}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    type="text"
                                />
                            )}
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.final_agent_valuation.displayName}
                            value={dataModel.bought_info.final_agent_valuation || ''}
                            onChange={(event) => this.handleChangeField('bought_info.final_agent_valuation', event.target.value)}
                            disabled={formIsLocked || isLoading}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.chip_value.displayName}
                            value={this.getValue('bought_info.chip_value', true)}
                            onChange={(event) => this.handleChangeField('bought_info.chip_value', event.target.value)}
                            disabled={formIsLocked || isLoading}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                </Col>
                <Col span={2} />
                <Col span={11}>
                    <div>
                        <TextField
                            label={boughtTree.final_purchase_price.displayName}
                            value={dataModel.bought_info.final_purchase_price || ''}
                            onChange={(event) => this.handleChangeField('bought_info.final_purchase_price', event.target.value)}
                            disabled={formIsLocked || isLoading}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.deferred_payment_amount.displayName}
                            value={dataModel.bought_info.deferred_payment_amount || ''}
                            onChange={(event) => this.handleChangeField('bought_info.deferred_payment_amount', event.target.value)}
                            disabled={formIsLocked || isLoading}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.deferred_payment_type.displayName}
                            value={dataModel.bought_info.deferred_payment_type || ''}
                            onChange={(event) => this.handleChangeField('bought_info.deferred_payment_type', event.target.value)}
                            disabled={formIsLocked || isLoading}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            // type="number"
                        />
                    </div>
                    <div>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                // disableToolbar
                                variant="inline"
                                inputVariant="outlined"
                                label={boughtTree.deferred_payment_date.displayName}
                                disabled={formIsLocked || isLoading}
                                value={dataModel.bought_info.deferred_payment_date || null}
                                onChange={(value) => this.handleChangeField('bought_info.deferred_payment_date', value.toISOString())}
                                // InputAdornment={{ position: 'end' }}
                                autoOk
                                format="D MMM YYYY"
                                margin="dense"
                                fullWidth
                                orientation="landscape"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.bank_transfer_amount.displayName}
                            value={dataModel.bought_info.bank_transfer_amount || ''}
                            onChange={(event) => this.handleChangeField('bought_info.bank_transfer_amount', event.target.value)}
                            disabled={formIsLocked || isLoading}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div style={{ marginTop: 7 }}>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    onChange={(event) => this.handleChangeField('tcard', event.target.checked)}
                                    checked={dataModel.tcard}
                                    disabled={formIsLocked || isLoading}
                                    color="secondary"
                                />
                            )}
                            label={finTree.tcard.displayName}
                        />
                    </div>
                </Col>
            </Row>
        );
    }
}

export default withStyles(styles)(PostTransactionDetails);



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/paymentApproval/PostTransactionDetails.js